import React from 'react';
import SvgComponent from 'components/Form/SvgComponent';
import ValidationElement from '../ValidationElement';
import Dropdown from '../Dropdown';

export default class MultipleDropdown extends ValidationElement {
  constructor(props) {
    super(props);

    this.state = {
      uid: `${this.props.name}-${super.guid()}`,
    };

    this.remove = this.remove.bind(this);
    this.update = this.update.bind(this);
    this.updateToken = this.updateToken.bind(this);
    this.handleError = this.handleError.bind(this);

    this.dropdown = React.createRef();
  }

  update(queue) {
    this.props.onUpdate({
      value: this.props.value,
      ...queue,
    });

    this.handleError(queue, []);
  }

  updateToken(event, options) {
    // If one has already been selected then no need to add it again
    if (this.props.value?.some((x) => x === options.suggestion.value)) {
      return;
    }
    const isNone = options?.suggestion?.value === 'None';

    const values = isNone ? [options.suggestion.value] : (this.props.value || []).concat([options.suggestion.value]);
    this.update({
      value: values,
    });
  }

  remove(index) {
    const arr = [...(this.props.value || [])];
    arr.splice(index, 1);

    this.update({
      value: arr,
    });
  }

  handleError(value, arr) {
    const local = this.constructor.errors.map((err) => ({
      code: err.code,
      valid: err.func(value, this.props),
      uid: this.state.uid,
    }));

    return this.props.onError(
      value,
      arr.filter((x) => x.code.indexOf('required') === -1).concat(local)
    );
  }

  render() {
    const values = this.props.value || [];
    const klass = `multiple-dropdown ${this.props.className || ''} ${
      values.length ? 'has-tokens' : ''
    }`.trim();
    const tokens = values.map((x, i) => (
      <span className="token" key={`${this.props.name}-${x}`}>
        {x}
        <span
          className="cross-circle"
          title="Remove Country"
          role="button"
          onClick={this.remove.bind(this, i)}
          onKeyPress={this.remove.bind(this, i)}
          tabIndex={0}
        >
          <SvgComponent className="cross-circle" src="/img/cross-circle.svg" />
        </span>
      </span>
    ));

    return (
      <div className={klass}>
        <Dropdown
          name={this.props.name}
          ref={this.dropdown}
          label={this.props.label}
          showComments={this.props.showComments}
          comments={this.props.comments}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          required={false}
          clearOnSelection
          onSuggestionSelected={this.updateToken} // eslint-disable-line @typescript-eslint/unbound-method
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          multiple={this.props.multiple}
          attribute={this.props.attribute}
        >
          {this.props.children}
        </Dropdown>
        {this.props.multipleLabel}
        <span className="tokens">{tokens}</span>
      </div>
    );
  }
}

MultipleDropdown.defaultProps = {
  name: 'multiple-dropdown',
  label: '',
  placeholder: '',
  maxlength: 255,
  disabled: false,
  explicit: true,
  pattern: '',
  readonly: false,
  className: '',
  input: '',
  value: [],
  showComments: false,
  comments: '',
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};

MultipleDropdown.errors = [
  {
    code: 'required',
    func: (value, props) => {
      if (props.required) {
        return !!props.value && !!props.value.length;
      }
      return true;
    },
  },
];
